import CardForm from "../payment/cardForm";
import PayPalLoginButton from "../payment/payPalLoginButton";

const PaymentForm = (props) => {
  const {
    paymentType,
    totalAmount,
    //  billingAddress,
    // email,
    onPaymentSuccess,
    onPaymentError,
    isProcessing,
  } = props;

  return (
    <>
      <div className="payment-form">
        <h4 className="payment-form-title">Invoice payment</h4>
        {paymentType === "cc" && (
          <div className="payment-detail-heading">
            <b>Enter Your Payment Details</b>
          </div>
        )}

        <div className="payment-amount-box">
          <div className="mTop12px text-right">
            <div className="bg-amount">
              <strong>
                <b>Amount</b>
              </strong>
              <span id="finalPricepp"> &nbsp;{totalAmount.toFixed(2)}</span>
              <span>&ensp;AUD</span>
            </div>
          </div>
        </div>
        {isProcessing && (
          <div style={{ textAlign: "center", fontSize: "18px" }}>
            <p>
              Processing your payment securely...
              <br />
              <strong>Please do not close or refresh this window.</strong>
            </p>
          </div>
        )}

        {paymentType === "cc" && (
          <CardForm
            onPayment={onPaymentSuccess}
            onError={onPaymentError}
            amount={totalAmount.toFixed(2)}
          />
        )}

        {paymentType === "paypal" && (
          <div className="by-payPal">
            <PayPalLoginButton
              onPayment={onPaymentSuccess}
              onError={onPaymentError}
              amount={totalAmount.toFixed(2)}
            />
          </div>
        )}
      </div>
    </>
  );
};

export default PaymentForm;
